export enum InputType {
  Label = 1,
  Input,
  Checkbox,
  MultiSelect,
  Question = 5,
  RadioGroup = 6,
  Rewest = 7,
}

export const REWST_TEMPLATE_TYPE = 3;
export const REWST_TEMPLATE_INPUT_TYPE = 7;

